import { WebAudioNode } from "./node.js";

class WebAudioNodeGain extends WebAudioNode {
  namespace = "webaudio:node:gain";
}

const webAudioNodeGain = new WebAudioNodeGain();
export { webAudioNodeGain, WebAudioNodeGain };
